<div *ngIf="entity" editorType="medium">
  <form *ngIf="form" [formGroup]="form">
    <div class="column">
        <dx-text-box formControlName="name" formField></dx-text-box>
        <dx-lookup
        [label]="'menu.breadcrumb.operations' | translate"
        [gsResource]="operationTypes"
        formControlName="operationTypeId"
        displayExpr="name"
        valueExpr="id"
        formField required
      ></dx-lookup>
      <dx-tag-box *ngIf="routingOperations" [dataSource]="routingOperations"
      [label]="'entity.resourceAllocation.dependencies' | translate"
      formControlName="dependencies"
      displayExpr="name"
      valueExpr="id"
      formField
      ></dx-tag-box>
    </div>
  </form>
  <div class="controls">
    <dx-tab-panel class="tabs-content">
      <dxi-item class="mt-3" [title]="'entity.resourceAllocation.workProcedure' | translate | ucfirst" dataType="string">
        <div class="p-3" style="height: 90%">
          <div class="flex flex-row items-center mb-3">
            <dx-lookup
              [width]="616"
              [label]="'entity.resourceAllocation.workProcedure' | translate"
              [gsResource]="workProcedures"
              [(value)]="routingOperation!.workProcedureId"
              displayExpr="name"
              valueExpr="id"
              [showClearButton]="false"
              itemTemplate="WorkProcedure"
              fieldTemplate="WorkProcedure"
              (onSelectionChanged)="onWorkProcedureChange($event)"
              [backendFilters]="{ 'documentTypeId': this.routing?.documentTypeId ?? ''}"
            >
              <div *dxTemplate="let wp of 'WorkProcedure'">
                <div *ngIf="wp">
                  <div style="white-space: normal">{{ wp.code }} | {{ wp.name }}</div>
                  <div style="white-space: normal" > {{'entity.bom.version' | translate| ucfirst}}: {{ wp.version }}</div>
                </div>
              </div>
            </dx-lookup>

            <dx-button
              hint="add work procedure"
              icon="add"
              class="mb-3 m-1"
              (click)="addWorkProcedure()">
            </dx-button>

            <dx-button
              hint="copy work procedure"
              icon="copy"
              class="mb-3 m-1"
              [disabled]="!routingOperation!.workProcedureId"
              (click)="copyWorkProcedure()">
            </dx-button>
            <div
              *ngIf="workProcedure"
              class="px-3 py-1 rounded-full text-white text-center mb-3 ml-1"
              [style]="{backgroundColor: stateColors[workProcedure!.stateId]}"
              title="{{ states[workProcedure!.stateId] | ucfirst }}"
            >{{ states[workProcedure!.stateId] | ucfirst }}</div>
          </div>

          <div class="mt-3 h-full">
            <dx-tab-panel class="h-full">
              <dxi-item [title]="'common.steps' | translate | ucfirst" dataType="string">
                <div class="h-full flex flex-col">
                  <dx-data-grid
                    *ngIf="steps"
                    [createComponent]="stepsAddComponent"
                    [customParams]="{ parentId: routingOperation!.workProcedureId }"
                    [glamResource]="steps"
                    [editingLocked]="!isWorkProcedureDraft"
                  >
                    <dxi-column sortOrder="asc" [sortIndex]="0" dataField="order"
                                 dataType="number"
                                [visible]="false">
                    </dxi-column>
                    <dxi-column
                      *ngIf="isWorkProcedureDraft"
                      [link]="{ editComponent: stepsEditComponent }"
                      [allowEditing]="false"
                      dataField="instructions"
                      dataType="string"
                      [caption]="'entity.workProcedure.step.instructions' | translate | ucfirst"
                    ></dxi-column>
                    <dxi-column
                      *ngIf="!isWorkProcedureDraft"
                      [allowEditing]="false"
                      dataField="instructions"
                      dataType="string"
                      [caption]="'entity.workProcedure.step.instructions' | translate | ucfirst"
                    ></dxi-column>
                    <dxi-column
                      cellTemplate="checkpointCellTpl"
                      [allowEditing]="false"
                      dataField="checkpointId"
                      [caption]="'common.checkpoint' | translate | ucfirst"
                    >
                      <div *dxTemplate="let cell of 'checkpointCellTpl'">
                        {{ getCheckpointName(cell.data.checkpointId) }}
                      </div>
                    </dxi-column>
                    <dxi-column
                      cellTemplate="defaultValuesCellTpl"
                      [allowEditing]="false"
                      dataField="defaultValues"
                      [caption]="'entity.workProcedure.step.defaultValues' | translate | ucfirst"
                    >
                      <div *dxTemplate="let cell of 'defaultValuesCellTpl'">
                        {{ formatDefaultValues(cell.value) }}
                      </div>
                    </dxi-column>
                    <dxi-column
                      [allowEditing]="false"
                      dataField="instructionsValue"
                      dataType="number"
                      [caption]="'entity.workProcedure.step.instructionsValue' | translate | ucfirst"
                    ></dxi-column>
                    <dxi-column
                      [allowEditing]="false"
                      dataField="required"
                      dataType="boolean"
                      [caption]="'entity.workProcedure.step.required' | translate | ucfirst"
                    ></dxi-column>
                  </dx-data-grid>
                </div>
              </dxi-item>
              <dxi-item
                [visible]="!!routingOperation?.workProcedureId"
                [title]="'generic_editor.images_gallery' | translate | ucfirst"
              >
                <div class="h-full flex flex-col">
                  <gs-entity-images-gallery
                    *ngIf="workProcedure"
                    [entityId]="routingOperation!.workProcedureId"
                    [resource]="$any(workProcedures)"
                    [disableImages]="!isWorkProcedureDraft"
                  ></gs-entity-images-gallery>
                </div>
              </dxi-item>
              <dxi-item
                [visible]="!!routingOperation?.workProcedureId"
                [title]="'generic_editor.files_manager' | translate | ucfirst"
              >
                <div class="h-full flex flex-col">
                  <gs-entity-files-manager
                    *ngIf="workProcedure"
                    [entityId]="routingOperation!.workProcedureId"
                    [resource]="$any(workProcedures)"
                    [disableFiles]="!isWorkProcedureDraft"
                  ></gs-entity-files-manager>
                </div>
              </dxi-item>
            </dx-tab-panel>
          </div>
        </div>
      </dxi-item>
      <dxi-item class="mt-3" [title]="'entity.resourceAllocation.resourceAllocations' | translate | ucfirst" dataType="string">
        <div class="h-full flex flex-col">
          <dx-data-grid (onSelectionChanged)="onSelectionChanged()" #grid [glamResource]="resourceAllocations"  [customParams]="{routingId: routing!.id, operationId: entity.id}"  [createComponent]="resourceAllocationAdd">
            <dxo-row-dragging
              [allowReordering]="true"
              [onReorder]="onReorder"
              [showDragIcons]="true"
            ></dxo-row-dragging>
            <dxo-toolbar>
              <dxi-item *ngIf="grid" location="before" name="copy" [disabled]="true">
                <div *dxTemplate="let item of 'copy'">
                  <dx-button type="normal" (onClick)="copyRow()" icon="copy" ></dx-button>
                </div>
              </dxi-item>
            </dxo-toolbar>
            <dxi-column dataField="cycleQuantity" dataType="number" [caption]="'entity.resourceAllocation.cycle' | translate | ucfirst"></dxi-column>
            <dxi-column
            dataField="setup"
            [caption]="'entity.resourceAllocation.setupShort' | translate | ucfirst"
            dataType="string"
            [editorOptions]="{
              mask: '00:00:00',
              maskPlaceholder: 'HH:MM:SS',
              useMaskedValue: true
            }">
            </dxi-column>
            <dxi-column   [editorOptions]="{
              mask: '00:00:00',
              maskPlaceholder: 'HH:MM:SS',
              useMaskedValue: true
            }"
             dataField="process"  [caption]="'entity.resourceAllocation.process' | translate | ucfirst"></dxi-column>
            <dxi-column   [editorOptions]="{
              mask: '00:00:00',
              maskPlaceholder: 'HH:MM:SS',
              useMaskedValue: true
            }"
            dataField="teardown"  [caption]="'entity.resourceAllocation.teardownShort' | translate | ucfirst"></dxi-column>
            <dxi-column cellTemplate="workcentersCell" editCellTemplate="workcentersEdit" dataField="workCenters" [caption]="'entity.resourceAllocation.workCenters' | translate | ucfirst">
              <div *dxTemplate="let item of 'workcentersCell'">
                {{concatNames(item.data.workCenters)}}
              </div>
              <div *dxTemplate="let data of 'workcentersEdit'">
                <dx-tag-box
                  [gsResource]="workcenters"
                  [value]="getWorkCenterIds(data.value)"
                  displayExpr="breadcrumb"
                  valueExpr="id"
                  [searchEnabled]="true"
                  [searchExpr]="'breadcrumb'"
                  [searchMode]="'contains'"
                  (onValueChanged)="saveWorkcenters(data, $event)">
                </dx-tag-box>
              </div>
            </dxi-column>

            <dxi-column cellTemplate="equipmentsCell" editCellTemplate="equipmentsEdit" dataField="equipments" [caption]="'entity.resourceAllocation.equipments' | translate | ucfirst">
              <div *dxTemplate="let item of 'equipmentsCell'">
                {{concatNames(item.data.equipments)}}
              </div>
              <div *dxTemplate="let data of 'equipmentsEdit'">
                <dx-tag-box
                  [gsResource]="equipments"
                  [value]="getEquipmentIds(data.value)"
                  displayExpr="name"
                  valueExpr="id"
                  [searchEnabled]="true"
                  [searchExpr]="'name'"
                  [searchMode]="'contains'"
                  [valueChangeEvent]="'blur'"
                  (onValueChanged)="saveEquipments(data, $event)">
                </dx-tag-box>
              </div>
            </dxi-column>

            <dxi-column
            dataField="toolings"
            [width]="180"
            [caption]="'menu.breadcrumb.toolings' | translate | ucfirst"
            cellTemplate="toolingsCell"
            editCellTemplate="toolingsEdit">

            <!-- Template para mostrar en la celda -->
            <div *dxTemplate="let item of 'toolingsCell'">
              {{ concatNames(item.data.toolings) }}
            </div>

            <!-- Template para editar con dx-tag-box -->
            <div *dxTemplate="let data of 'toolingsEdit'">
              <dx-tag-box
                [gsResource]="toolings"
                [value]="getToolingIds(data.value)"
                displayExpr="name"
                valueExpr="id"
                [searchEnabled]="true"
                [searchExpr]="'name'"
                [searchMode]="'contains'"
                [valueChangeEvent]="'blur'"
                tagTemplate="toolingTagTemplate"
                (onValueChanged)="saveToolings(data, $event)">
                <div *dxTemplate="let item of 'toolingTagTemplate'">
                  <div *ngIf="item" class="dx-tag-content">
                    <div  (click)="onToolingClick($event, item, data)"   class="tag-text hover:underline">{{ item.name }} {{ getQuantityForTag(item.id, data.value) }}</div>
                    <div class="dx-tag-remove-button"></div>
                  </div>
                </div>
              </dx-tag-box>
            </div>

          </dxi-column>

            <dxi-column
            dataField="workforces"
            [caption]="'entity.resourceAllocation.workForces' | translate | ucfirst"
            cellTemplate="workforcesCell"
            editCellTemplate="workforcesEdit">

            <div *dxTemplate="let item of 'workforcesCell'">
              {{ concatNames(item.data.workforces) }}
            </div>

            <div *dxTemplate="let data of 'workforcesEdit'">
              <dx-tag-box
                [gsResource]="workforces"
                [value]="getWorkForcesIds(data.value)"
                displayExpr="name"
                valueExpr="id"
                tagTemplate="workforceTagTemplate"
                (onValueChanged)="saveWorkforces(data, $event)">

                <div *dxTemplate="let item of 'workforceTagTemplate'">
                  <div class="dx-tag-content">
                    <div (click)="onWorkforceClick($event, item, data)" class="tag-text hover:underline">
                      {{ item.name }} ({{ getOccupationForTag(item.id, data.value) * 100 | number:'1.0-0' }}%)
                    </div>
                    <div class="dx-tag-remove-button"></div>
                  </div>
                </div>
              </dx-tag-box>
            </div>
          </dxi-column>

            <dxi-column  cellTemplate="workersCell" editCellTemplate="workersEdit" dataField="workers" [caption]="'entity.resourceAllocation.workers' | translate | ucfirst">
              <div *dxTemplate="let item of 'workersCell'">
                {{concatNames(item.data.workers)}}
              </div>
              <div *dxTemplate="let data of 'workersEdit'">
                <dx-tag-box
                  [gsResource]="workers"
                  [value]="getWorkerIds(data.value)"
                  displayExpr="name"
                  valueExpr="id"
                  [searchEnabled]="true"
                  [searchExpr]="'name'"
                  [searchMode]="'contains'"
                  (onValueChanged)="saveWorkers(data, $event)">
                </dx-tag-box>
              </div>
            </dxi-column>
          </dx-data-grid>
          </div>
      </dxi-item>
    </dx-tab-panel>
  </div>
</div>
<dx-popup
  [(visible)]="editPopupVisible"
  [width]="400"
  [height]="250"
  [showTitle]="true"
  title="Edit quantity"
  [dragEnabled]="false"
>

  <div *dxTemplate="let d of 'content'">
    <dx-number-box
      [(value)]="editingQuantity"
      [min]="1"
      [showSpinButtons]="true"
      [label]="'Quantity'"
      labelMode="floating">
    </dx-number-box>

    <div class="mt-4 flex justify-end gap-2">
      <dx-button text="Cancel" (onClick)="editPopupVisible=false"></dx-button>
      <dx-button text="Save" type="success" (onClick)="applyQuantityChange()"></dx-button>
    </div>
  </div>
</dx-popup>
<gs-popup
  [(visible)]="editWorkforcePopupVisible"
  [width]="400"
  [height]="220"
  [title]="'enumeration.CostTypes.Percentage' | translate"
  (save)="applyOccupationChange()"
>
  <form gs-popup-form #occupationForm="ngForm">
    <dx-number-box
      name="editingOccupation"
      [(ngModel)]="editingOccupation"
      [min]="0"
      [step]="0.01"
      [showSpinButtons]="true"
      [format]="'percent'"
      [label]="'percent'"
      labelMode="floating">
    </dx-number-box>
  </form>
</gs-popup>
